






























import { computed, defineComponent } from '@vue/composition-api';
import { trackEvent } from './../../../../utils/index';
const name = 'ttam-targeting-expansion-switch';
export default defineComponent({
  name,
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledHint: {
      type: String,
      default: '',
    },
    adgroupId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const _switchOn = computed({
      get() {
        return props.value;
      },
      set(val) {
        emit('input', val);
        emit('change', val);
      },
    });
    return {
      name,
      _switchOn,
      onHover: () => {
        if (!props.disabled) {
          return;
        }
        trackEvent('create_adgroup_target_expanded_hover');
      },
    };
  },
});
